import {
  MasterCarApiRequest,
  UpdateMasterCarRequest,
} from '@/data/payload/api/MasterCarRequest'
import {
  PostMasterCarInterface,
  DeleteMasterCarInterface,
  UpdateMasterCarInterface,
} from '@/data/payload/contracts/MasterCarRequest'
import ApiService from '@/app/framework/services/ApiServices'
import { MasterCarDataMapper } from '@/data/persistences/mappers/MasterCarDataMapper'
import { MasterCarRepositoryInterface } from '@/data/persistences/repositories/contracts/MasterCarRepositoryInterface'
import { MasterCar } from '@/domain/entities/MasterCar'
import { Endpoints } from '@/app/framework/misc/Endpoints'

export class MasterCarApiRepository implements MasterCarRepositoryInterface {
  private service: ApiService
  private mapper: MasterCarDataMapper

  constructor(service: ApiService, mapper: MasterCarDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async delete(payload: DeleteMasterCarInterface): Promise<MasterCar> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.TRAINING_CATEGORY_DELETE,
      undefined,
      payload as MasterCarApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async post(payload: PostMasterCarInterface): Promise<MasterCar> {
    const resp = await this.service.invoke(
      'post',
      Endpoints.Route.TRAINING_CATEGORY,
      undefined,
      payload as MasterCarApiRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async update(
    payload: UpdateMasterCarInterface,
    id: number
  ): Promise<MasterCar> {
    const resp = await this.service.invoke(
      'post',
      `${Endpoints.Route.TRAINING_CATEGORY}/${id}`,
      undefined,
      payload as UpdateMasterCarRequest
    )
    return this.mapper.convertBaseResponseFromApi(resp)
  }

  public async getAll(params: Object): Promise<MasterCar> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.TRAINING_CATEGORY,
      params
    )
    return this.mapper.convertFromApi(resp)
  }
}
